import { render, staticRenderFns } from "./mediaPublishCoverUpload.vue?vue&type=template&id=a5c00812&scoped=true&"
import script from "./mediaPublishCoverUpload.vue?vue&type=script&lang=js&"
export * from "./mediaPublishCoverUpload.vue?vue&type=script&lang=js&"
import style0 from "./mediaPublishCoverUpload.vue?vue&type=style&index=0&id=a5c00812&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c00812",
  null
  
)

component.options.__file = "mediaPublishCoverUpload.vue"
export default component.exports